<template>
  <div id="signup-container" class="mobile-authportal-container">
    <transition name="fade">
      <v-sheet
        key="1"
        v-if="registerSucceed"
        tile
        class="mobile-authportal-form-wrapper text-center"
      >
        <div class="icon-sprite mobile-authportal-signup-succeed mx-auto"></div>
        <div id="mobile-signup-succeed-header">Congratulations</div>
        <div id="mobile-signup-succeed-subheader">You may now log in your new account</div>
        <div id="signup-succeed-proceed-to-sign-in">
          <v-btn
            color="#e2211c"
            depressed
            width="270px"
            class="white--text my-6"
            tile
            to="/ap/signin"
          >log in ></v-btn>
        </div>
      </v-sheet>
      <v-sheet v-else tile class="mobile-authportal-form-wrapper">
        <div class="mobile-authportal-header text-uppercase" id="signup-header">sign up</div>

        <div
          class="mobile-authportal-form-subheader"
        >Please enter your name, email and password to sign up your account</div>
        <transition name="fade">
          <div class="mobile-authportal-error-container" v-if="hasError">
            <div class="icon-sprite mobile-authportal-error-icon"></div>
            <div class="mobile-authportal-error-message">{{ signupErrorMessage }}</div>
          </div>
        </transition>
        <v-form
          ref="signUpForm"
          v-model="isValid"
          lazy-validation
          class="mt-6 mobile-authportal-form"
        >
          <div class="mobile-authportal-form-field mt-3">
            <div class="mobile-authportal-form-field-label">name*</div>
            <div class="mobile-authportal-form-field-input">
              <div class="mobile-authportal-form-input">
                <v-text-field
                  v-model="name"
                  ref="name"
                  filled
                  solo
                  flat
                  required
                  type="text"
                  :rules="signUpNameRule"
                  hide-details
                ></v-text-field>
                <div
                  class="mobile-authportal-form-field-input-error-msg"
                  v-if="isMounted"
                >{{ inputFieldErrorMsg('name') }}</div>
              </div>
            </div>
          </div>
          <div class="mobile-authportal-form-field mt-3">
            <div class="mobile-authportal-form-field-label">email*</div>
            <div class="mobile-authportal-form-field-input">
              <div class="mobile-authportal-form-input">
                <v-text-field
                  v-model="username"
                  ref="username"
                  filled
                  solo
                  flat
                  required
                  type="text"
                  :rules="signUpUsernameRule"
                  hide-details
                ></v-text-field>
                <div
                  class="mobile-authportal-form-field-input-error-msg"
                  v-if="isMounted"
                >{{ inputFieldErrorMsg('username') }}</div>
              </div>
            </div>
          </div>
          <div class="mobile-authportal-form-field mt-3">
            <div class="mobile-authportal-form-field-label">password*</div>
            <div class="mobile-authportal-form-field-input">
              <div class="mobile-authportal-form-input">
                <v-text-field
                  v-model="password"
                  ref="password"
                  filled
                  solo
                  flat
                  required
                  type="password"
                  :rules="signUpPasswordRule"
                  hide-details
                ></v-text-field>
                <div
                  class="mobile-authportal-form-field-input-error-msg"
                  v-if="isMounted"
                >{{ inputFieldErrorMsg('password') }}</div>
              </div>
            </div>
          </div>
          <div class="mobile-authportal-hack-width d-flex justify-end">
            <div id="mobile-authportal-agree-to-condition">
              <v-checkbox :rules="agreeTermAndConditionRule" color="#e2211c" dense>
                <template v-slot:label>
                  <div id="agree-to-term-section" class="font-italic">
                    By registering, I agree to 1byone health's
                    <a
                      target="_blank"
                      href="/support/terms_condition"
                      @click.stop
                    >term and condition</a>
                  </div>
                </template>
              </v-checkbox>
            </div>
          </div>
          <div class="mobile-authportal-hack-width d-flex justify-end">
            <v-btn
              color="#e2211c"
              tile
              depressed
              width="270px"
              class="mt-4 white--text"
              @click="performSignup"
              :loading="performSignUpPending"
            >Register</v-btn>
          </div>
          <div
            id="mobile-authportal-existing-account"
            class="mobile-authportal-account-condition-hint my-5"
          >
            Already have an account ?
            <router-link to="/ap/signin">
              <span class="pb-1 ml-2">Sign In Now!</span>
            </router-link>
          </div>
        </v-form>
      </v-sheet>
    </transition>
  </div>
</template>

<script>
import authPortalMixins from "../../../mixins/authPortalMixins";
import authPortalSignUpMixins from "../../../mixins/authPortalSignUpMixins";

export default {
  mixins: [authPortalMixins, authPortalSignUpMixins]
};
</script>

<style scoped>
@import "../../../styles/mobile/authportalCommon.css";

#agree-to-term-section,
#agree-to-term-section a {
  color: #666666;
  font-size: 11px;
}

#agree-to-term-section a {
  border-bottom: 1px solid #666666;
}

#mobile-authportal-agree-to-condition {
  width: 260px;
}

.mobile-authportal-signup-succeed {
  height: 155px;
  width: 155px;
  background-position: 0px -72px;
}

#mobile-signup-succeed-header {
  color: #bb1c18;
  font-size: 23px;
  margin-top: 20px;
}

#mobile-signup-succeed-subheader {
  color: #333333;
  font-size: 15px;
  margin-top: 15px;
}
</style>